module.exports = __webpack_public_path__ + "media/images/countrysquared/wf-66f3d9fac1bc11d50834a5e56143a491.svg";